import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URI,
    responseType: "json"
});


export const getServices = async () => {
    return API.get('/services');
}

export const getService = async (id) => {
    return API.get('/services', { params: { id } });
}

export const getMembers = async () => {
    return API.get('/members');
}

export const getNews = async () => {
    return API.get('/news');
}